var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification"},[_c('notify-panel',{attrs:{"type":1,"notify":_vm.systemMsg}}),_c('notify-panel',{attrs:{"type":2,"notify":_vm.remindMsg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }